import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import commonStore from "../../Store/marco/commonStore";
import { companyId, inactiveYear } from "../utils/company-operating-status";

// Keep names as plain strings in stores: labels must not affect search or API payloads.
export const CompanyStatusLabel = observer(({ company, id, name, inline = false }) => {
  const { t } = useTranslation("OrgStructure");
  const key = id ?? companyId(company);
  const source = (commonStore.companyList || []).find((c) => String(c.id) === String(key));
  const year = inactiveYear(company?.inactiveSince !== undefined ? company : source);
  return <>
    {name ?? company?.companyName ?? company?.label}
    {year !== null && <span style={{
      display: inline ? "inline" : "block", fontSize: "0.8em", fontWeight: 400,
      marginLeft: inline ? 4 : 0, lineHeight: 1.5,
      color: inline ? "#5f6b7a" : "inherit",
    }}>{inline ? "· " : ""}{t("Inactive since {{year}}", { year, defaultValue: `Inactive since ${year}` })}</span>}
  </>;
});
